<template>
  <div class="box" :style="{ height: TableHeight + 'px' }">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="产品文件导入" name="0">
        <div class="uploads">
          <span>上传产品资源</span>
          <div
            style="cursor: pointer; display: flex; align-items: center"
            @click="download()"
          >
            <i
              class="el-icon-download"
              style="color: #409eff; font-size: 18px"
            ></i
            ><el-button
              type="text"
              size="mini"
              v-if="companyid != 0"
              style="font-size: 14px"
              >导出产品信息</el-button
            >
          </div>
        </div>
        <div class="uploadBox">
          <el-upload
            ref="adModel"
            class="upload-demo"
            drag
            :action="uploadfile"
            :before-upload="beforeAvatarUploads"
            :on-exceed="handleExceeds"
            :on-remove="handleRemoves"
            :limit="1"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
          <div class="saveBtn">
            <el-button type="primary" @click="save()">确 定</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="产品在线录入" name="1">
        <el-form ref="form" :model="form" label-width="100px">
          <br />
          <!-- <el-form-item label="选择公司">
            <el-select
              v-model="form.firmName"
              filterable
              placeholder="请选择选择公司"
              style="width: 300px"
              size="mini"
            >
              <el-option
                v-for="(item, index) in form.firm"
                :key="index"
                :label="item.name"
                :value="item.GZL_COMPANY_id_PK"
              ></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="分类\品种">
            <el-select
              v-model="form.category"
              filterable
              placeholder="请选择分类\品种"
              style="width: 300px"
              size="mini"
            >
              <el-option
                v-for="(item, index) in form.categorylist"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="商品材质">
            <el-select
              v-model="form.region"
              filterable
              placeholder="请选择商品材质"
              style="width: 300px"
              size="mini"
            >
              <el-option
                v-for="(item, index) in form.type"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地（厂家）">
            <el-input
              v-model="form.name"
              placeholder="请输入产地"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="含税价格">
            <el-input
              v-model="form.price"
              placeholder="请输入含税价格"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="会员价格">
            <el-input
              v-model="form.vip_price"
              placeholder="请输入会员价格"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="规格">
            <el-input
              v-model="form.specification"
              placeholder="请输入规格"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="库存">
            <el-input
              v-model="form.inventory"
              placeholder="请输入库存"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="所在地">
            <el-input
              v-model="form.location"
              placeholder="请输入所在地"
              style="width: 300px"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit(form)"
              >放入库存</el-button
            >
            <el-button style="margin-left: 100px" @click="putaway(form)"
              >立即上架</el-button
            >
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import {
  companyoption,
  businessinputproduct,
  uploadfile,
  exportbusinessproducts,
  importbusinessproducts,
} from "../../static/API/API.js";
import { publics } from "../js/public";
export default {
  data() {
    return {
      form: {
        name: "", //品牌
        price: "", //价格
        vip_price: "", //会员价格
        specification: "Φ", //规格
        inventory: "", //库存
        serve: "", //服务
        location: "", //所在地
        type: [], //商品材质
        region: "",
        firm: [], //选择公司
        firmName: sessionStorage.getItem("companyid"),
        categorylist: [],
      },
      TableHeight: 300,
      activeName: "0",
      templateFile: "",
      //向后端传递的图片接口
      uploadfile: uploadfile,
      fileList: [],
      companyid: "",
    };
  },
  mounted() {
    this.texture();
    this.firm();
    this.categorylist();
    this.getHeight();
    this.companyid = sessionStorage.getItem("companyid");
  },
  created() {
    window.addEventListener("resize", this.getHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },

  methods: {
    getHeight() {
      //动态计算表格高度
      this.$nextTick(() => {
        let windowHeight =
          document.documentElement.clientHeight || document.bodyclientHeight;
        this.TableHeight = windowHeight - 138; //数值"140"根据需要调整
      });
    },

    texture() {
      // 商品材质
      let params = new URLSearchParams();
      this.$axios.get(businessinputproduct, { params }).then((res) => {
        this.form.type = res.data;
      });
    },
    // 选择公司
    firm() {
      let params = new URLSearchParams();
      this.$axios.get(companyoption, { params }).then((res) => {
        this.form.firm = res.data;
      });
    },
    //分类列表
    categorylist() {
      publics(sessionStorage.getItem("companyid")).then((res) => {
        // this.materialArr = res.materialArr //产品名
        this.form.categorylist = res.varietyArr.map((item) => {
          return item.category;
        }); //品种
        // this.standardArr = res.standardArr //规格
        // this.factoryArr = res.factoryArr //厂家
        // this.warehouseArr = res.warehouseArr //仓库
        // this.optionArr = res.optionArr //采购类别
        // this.customUserArr = res.customUserArr //客户信息
        // this.craftArr = res.craftArr //工艺
        // this.unitArr = res.unitArr //计件单位
      });
    },
    // 放入库存
    onSubmit(e) {
      if(e.region == "" || e.category == "" || e.specification.substr(1) == '' || e.name == "" || e.inventory == "" || e.price == "" || e.vip_price == "" || e.inventory == ""){
        this.$message({
            type: "error",
            message: '请将数据信息填写完整！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if(Number(e.inventory) <= 0 ){
        this.$message({
            type: "error",
            message: '库存不能小于0！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if((Number(e.price) - Number(e.vip_price)) > 200){
        this.$message({
            type: "error",
            message: '会员价格与平台价格的差价不能超过200元！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if(Number(e.vip_price) >Number(e.price)){
        this.$message({
            type: "error",
            message: '会员价格不能高于平台价格！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      let params = new URLSearchParams();
      params.append("name", e.region); //材质
      params.append("spec", e.specification); //规格
      params.append("warehouse", e.location); //仓库
      params.append("factory", e.name); //品牌 厂家
      params.append("status", "待审核"); //审核状态
      params.append("entry_user", sessionStorage.getItem("user_id")); //入库人
      params.append("companyid", e.firmName); //友商公司id
      params.append("stock", e.inventory); //当前库存
      params.append("base_price", e.price); //基价
      params.append("platform_price", e.price); //平台价格
      params.append("vip_price", e.vip_price); //会员价格
      params.append("category", e.category); //分类品种

      this.$axios.post(businessinputproduct, params).then((res) => {
        if (res.data == "ok") {
          this.$message({
            type: "success",
            message: res.data,
            duration: 1000,
            showClose: true,
          });
          this.form.name = "";
          this.form.vip_price = "";
          this.form.price = "";
          this.form.specification = "Φ";
          this.form.inventory = "";
          this.form.serve = "";
          this.form.location = "";
          this.form.region = "";
          // this.form.firmName = "";
          this.form.category = "";
        } else {
          this.$message({
            type: "error",
            message: res.data,
            duration: 1000,
            showClose: true,
          });
        }
      });
    },
    // 立即上架
    putaway(e) {
      if(e.region == "" || e.category == "" || e.specification.substr(1) == '' || e.name == "" || e.inventory == "" || e.price == "" || e.vip_price == "" || e.inventory == ""){
        this.$message({
            type: "error",
            message: '请将数据信息填写完整！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if(Number(e.inventory) <= 0 ){
        this.$message({
            type: "error",
            message: '库存不能小于0！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if((Number(e.price) - Number(e.vip_price)) > 200){
        this.$message({
            type: "error",
            message: '会员价格与平台价格的差价不能超过200元！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      if(Number(e.vip_price) > Number(e.price)){
        this.$message({
            type: "error",
            message: '会员价格不能高于平台价格！',
            duration: 1000,
            showClose: true,
          });
          return
      }
      let producData = []
      const confirmText = [`品种为：${e.category}`,  `商品材质为：${e.region}`,`规格为：${e.specification}`,`产地为：${e.name}`,`平台价格为：：${e.price}`,`会员价格为：${e.vip_price}`,`库存为：${e.vip_price}`,'确定要上架该产品？'] 
    //   this.newTableData && this.newTableData.process_products.forEach((item,index)=>{
    //   let produc = `产品信息${index+1}:` + `品种为：${item.category}、` + `材质为：${item.p_name}、` + `规格为：${item.spec}、` + `数量为：${item.into_num}吨、` + `产地为：${item.factory}、` + `成品规格为：${item.result_spec}、` + `件数为：${item.cases_num}`
    //   producData.push(produc)
    // })
    // producData = producData.concat(confirmText)
      const h = this.$createElement
      let newDatas = []
        for (const i in confirmText) {
          newDatas.push(h('p', null, confirmText[i]))
        }

      this.$confirm(`当前产品信息如下：`,
      {
            title: '当前产品信息如下：',
            message: h('div', null, newDatas),
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
      }
      )
        .then((_) => {
          let params = new URLSearchParams();
      params.append("name", e.region); //材质
      params.append("spec", e.specification); //规格
      params.append("warehouse", e.location); //仓库
      params.append("factory", e.name); //品牌 厂家
      params.append("status", "已审核"); //审核状态
      params.append("entry_user", sessionStorage.getItem("user_id")); //入库人
      params.append("companyid", e.firmName); //友商公司id
      params.append("stock", e.inventory); //当前库存
      params.append("base_price", e.price); //基价
      params.append("platform_price", e.price); //平台价格
      params.append("vip_price", e.vip_price); //会员价格
      params.append("category", e.category); //分类品种
      this.$axios.post(businessinputproduct, params).then((res) => {
        if (res.data == "ok") {
          this.$message({
            type: "success",
            message: res.data,
            duration: 1000,
            showClose: true,
          });
          this.form.name = "";
          this.form.price = "";
          this.form.vip_price = "";
          this.form.specification = "Φ";
          this.form.inventory = "";
          this.form.serve = "";
          this.form.location = "";
          this.form.region = "";
          // this.form.firmName = "";
          this.form.category = "";
        } else {
          this.$message({
            type: "error",
            message: res.data,
            duration: 1000,
            showClose: true,
          });
        }
      });
        })
        .catch((_) => {});
    },
    handleClick(tab, event) {
    },
    beforeAvatarUploads(file) {
      this.templateFile = file;
    },
    handleExceeds() {
      this.$message({
        title: "",
        message: "最多上传一个文件！",
        type: "error",
        duration: 1000,
        showClose: true,
      });
    },
    handleRemoves() {
      this.templateFile = "";
    },
    // 确定保存
    save() {
      if (this.templateFile == "") {
        this.$message({
          title: "",
          message: "请上传文件！",
          type: "error",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      let fd = new FormData();
      fd.append("companyid", this.companyid); //友商公司id
      fd.append("file_name", this.templateFile); //文件名称
      this.$axios.post(importbusinessproducts, fd).then((res) => {
        if ((res.data = "ok")) {
          this.$message({
            title: "",
            message: "上传成功",
            type: "success",
            duration: 1000,
            showClose: true,
          });
          this.fileList = [];
        } else {
          this.$message({
            title: "",
            message: res.data,
            type: "error",
            duration: 1000,
            showClose: true,
          });
        }
      });
    },
    // 友商产品表格下载
    download() {
      let params = new URLSearchParams();
      params.append("companyid", this.companyid);
      this.$axios.post(exportbusinessproducts, params).then((res) => {
        if (res.data.includes("http")) {
          window.open(res.data);
          setTimeout(() => {
            this.$message({
              type: "success",
              message: `下载成功！`,
              duration: 1000,
              showClose: true,
            });
          }, 500);
        } else {
          this.$message({
            type: "info",
            message: res.data,
            duration: 1000,
            showClose: true,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.el-form {
  background-color: #fff;
  /* padding: 100px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.el-select {
  width: 30%;
}
.el-input {
  width: 30%;
}
.title {
  font-weight: 600;
}
/deep/ .el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-tabs__item {
  font-weight: bold;
}
.uploads {
  margin: 20px 0;
  display: flex;
  align-items: center;
}
.uploads span {
  margin-right: 10px;
}
/deep/ .el-upload-dragger {
  width: 650px;
}
/deep/ .el-upload-list__item {
  width: 650px;
}
.saveBtn {
  width: 650px;
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.uploadBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 150px;
}
</style>



// WEBPACK FOOTER //
// src/views/YoushangProduct.vue